// extracted by mini-css-extract-plugin
export var legendIndicator = "_ib-1";
export var legendRight = "_ib-0";